import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ArchitecturalAndDetailedDesignModule = () => (
  <QPhototModuleSubtopic
    title="Architectural design, Detailed Design, Transaction Transformation, Refactoring of designs"
    videos={[
      "https://www.youtube.com/embed/3BaLG6KL5Ac",
      "https://www.youtube.com/embed/x3OT-KftMps",
      "https://www.youtube.com/embed/PvcbiYyxbUQ",
      "https://www.youtube.com/embed/PiawGKWcswc"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "A Food Delivery System follows the workflow given below:\n• A customer places an order by selecting items from a menu.\n• The system verifies the payment and generates an order confirmation.\n• The order is sent to the restaurant for preparation.\n• Once prepared, a delivery agent is assigned.\n• The delivery agent picks up the order and delivers it to the customer.\nDoes this system exhibit transaction flow or transform flow? Justify your answer by explaining how the control of execution flows through the different processes."
      },
      {
        text:
          "Imagine you are developing firmware for a microcontroller-based IoT device that monitors environmental conditions such as temperature, humidity, and air quality in a smart home. The device continuously samples sensor data and sends periodic updates to a central server for analysis and visualization. To efficiently handle asynchronous events and minimize CPU overhead, identify the appropriate architecture control style for the scenario and justify the same."
      }
    ]}
    exampleVideos={[]}
  />
);

export default ArchitecturalAndDetailedDesignModule;
